import React from 'react';
import { Button } from '../ui/Button';

const presets = {
  free: { rpm: 10, rph: 500, rpd: 10000 },
  basic: { rpm: 50, rph: 2500, rpd: 50000 },
  professional: { rpm: 100, rph: 5000, rpd: 100000 },
  enterprise: { rpm: 500, rph: 25000, rpd: 500000 },
  unlimited: { rpm: null, rph: null, rpd: null },
};

interface RateLimitPresetsProps {
  onApply: (preset: { rpm: number | null; rph: number | null; rpd: number | null }) => void;
}

export const RateLimitPresets: React.FC<RateLimitPresetsProps> = ({ onApply }) => {
  return (
    <div className="flex flex-wrap gap-2">
      {Object.entries(presets).map(([key, preset]) => (
        <Button key={key} type="button" variant="secondary" onClick={() => onApply(preset)}>
          {key}
        </Button>
      ))}
    </div>
  );
};

export default RateLimitPresets;
